import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import FormattersStore from '../stores/Formatters';
import dataAids from '../constants/dataAids';
import { Translate as translate } from '@wsb/vnext-widget-content-translate';

const styles = {
  inline: {
    display: 'inline'
  },
  sectionLabel: {
    fontWeight: 'bold'
  },
  serviceCostDetailsRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  serviceCostDetailsWrapper: {
    '@xs-only': {
      paddingBottom: 'xsmall'
    },
    '@sm': {
      paddingBottom: 'large'
    }
  },
  serviceCostDetailsText: {
    marginBottom: '0'
  },
  serviceCostDetailsBold: {
    marginBottom: '0',
    fontWeight: 'bold'
  },
  serviceTotalInclude: {
    marginBottom: '0',
    fontStyle: 'italic'
  }
};

export default class ServiceCostDetails extends Component {
  isTaxAmountShown() {
    const {
      service: { tax_amount: taxAmount }
    } = this.props;
    return Number(taxAmount) > 0;
  }

  render() {
    const { service, isTaxRateShown, staticContent } = this.props;
    const { Block, Label, Text } = UX2.Element;
    const { numberFormatter } = FormattersStore.getState();
    const taxName = (service.tax_category && service.tax_category.name) || staticContent.tax;

    const interpolate = translate(staticContent);

    return (
      <Block
        style={ styles.serviceCostDetailsWrapper }
        data-aid={ dataAids.SERVICE_COST_AMOUNT_DETAILS }
      >
        <Label style={ styles.sectionLabel }>{ staticContent.serviceAmount }</Label>
        { this.isTaxAmountShown() && (
          <Fragment>
            <Block style={ styles.serviceCostDetailsRow }>
              <Text style={ styles.serviceCostDetailsText }>{ staticContent.subtotal }</Text>
              <Text style={ styles.serviceCostDetailsText } data-aid={ dataAids.SERVICE_COST_SUBTOTAL }>
                { numberFormatter.formatCurrency(Number(service.cost)) }
              </Text>
            </Block>
            <Block style={ styles.serviceCostDetailsRow }>
              <Text
                style={ styles.serviceCostDetailsText }
                data-aid={ dataAids.SERVICE_COST_TAX_LABEL }
              >
                { taxName }
                { isTaxRateShown && (
                  <Text style={ styles.inline } data-aid={ dataAids.SERVICE_COST_TAX_RATE }>
                    { ` ${numberFormatter.formatPercentage(service.tax_category.rate)}` }
                  </Text>
                ) }
              </Text>
              <Text style={ styles.serviceCostDetailsText } data-aid={ dataAids.SERVICE_COST_TAX }>
                { numberFormatter.formatCurrency(Number(service.tax_amount)) }
              </Text>
            </Block>
          </Fragment>
        ) }
        <Block style={ styles.serviceCostDetailsRow }>
          <Text style={ styles.serviceCostDetailsBold }>{ staticContent.total }</Text>
          <Text style={ styles.serviceCostDetailsBold } data-aid={ dataAids.SERVICE_COST_TOTAL }>
            { this.isTaxAmountShown()
              ? numberFormatter.formatCurrency(Number(service.cost_with_tax))
              : numberFormatter.formatCurrency(Number(service.cost)) }
          </Text>
        </Block>
        <Text style={ styles.serviceTotalInclude }>
          { interpolate('totalIncludesTax', { taxName }) }
        </Text>
      </Block>
    );
  }
}

ServiceCostDetails.propTypes = {
  service: PropTypes.object,
  staticContent: PropTypes.object.isRequired,
  isTaxRateShown: PropTypes.bool
};
